<div
    role="group"
    class="agpr-formField agpr-buttonStyleField-container"
    [attr.aria-label]="field.label | localize"
>
    <div class="agpr-formField-heading">
        <span class="agpr-formField-headingLabel">
            {{ field.label | localize }}
        </span>
        <span class="agpr-formField-headingButtons">
            @if(field.allowExpertMode) {
                <agpr-button
                    class="agpr-formField-headingButton"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-code"
                    tooltip="PageBuilder.formField.tooltip.expertTemplateEditor"
                    tooltipPosition="top"
                    (click)="saveExpertTemplate()"
                ></agpr-button>
            }
            <agpr-button
                class="agpr-formField-headingButton"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-duotone fa-floppy-disk"
                tooltip="PageBuilder.formField.tooltip.saveStyle"
                tooltipPosition="top"
                (click)="saveStyle()"
            ></agpr-button>
        </span>
    </div>

    @if (field.showStyleState) {
        <div class="agpr-buttonStyleField-styleState">
            <div class="agpr-inputGroupRow">
                <div class="agpr-inputGroupRow-dropdown">
                    <agpr-dropdown-field
                        [id]="id + '_styleStateDropdown'"
                        [value]="value.displayStyleState"
                        [field]="styleStateField"
                        (changes)="setStyle($event, styleStateField.property)"
                    ></agpr-dropdown-field>
                </div>
                <div class="agpr-inputGroupRow-buttons">
                    <agpr-button
                        [id]="id + '_button_corner_slider'"
                        [style]="buttonTypes.block"
                        icon="fa-regular fa-duotone fa-gear"
                        tooltip="PageBuilder.formField.tooltip.manageStyles"
                        tooltipPosition="top"
                        (click)="manageStylesButtonClicked()"
                    ></agpr-button>
                </div>
            </div>
        </div>
    }

    @if (!value.template) {
        <div class="agpr-buttonStyleField agpr-buttonStyleField-content">
            <div class="agpr-buttonStyleField-buttonAlignment">
                <agpr-radio
                    class="agpr-buttonStyleField-button agpr-buttonStyleField-button--start"
                    [id]="id + '_leftRadioButtonAlignmentButton'"
                    name="buttonAlignment-{{ id }}"
                    [value]="buttonAlignmentEnum.left"
                    [style]="radioTypesEnum.button"
                    [icon]="'fa-regular fa-duotone fa-objects-align-left'"
                    [iconTooltip]="'PageBuilder.formField.tooltip.alignLeft'"
                    hiddenLabel="PageBuilder.formField.tooltip.alignLeft"
                    [(ngModel)]="value.buttonAlignment"
                    (onClick)="setStyle(buttonAlignmentEnum.left, 'buttonAlignment')"
                ></agpr-radio>
                <agpr-radio
                    class="agpr-buttonStyleField-button"
                    [id]="id + '_centerRadioButtonAlignmentButton'"
                    name="buttonAlignment-{{ id }}"
                    [value]="buttonAlignmentEnum.center"
                    [style]="radioTypesEnum.button"
                    [icon]="'fa-regular fa-duotone fa-objects-align-center-horizontal'"
                    [iconTooltip]="'PageBuilder.formField.tooltip.alignCenter'"
                    hiddenLabel="PageBuilder.formField.tooltip.alignCenter"
                    [(ngModel)]="value.buttonAlignment"
                    (onClick)="setStyle(buttonAlignmentEnum.center, 'buttonAlignment')"
                ></agpr-radio>
                <agpr-radio
                    class="agpr-buttonStyleField-button"
                    [id]="id + '_rightRadioButtonAlignmentButton'"
                    name="buttonAlignment-{{ id }}"
                    [value]="buttonAlignmentEnum.right"
                    [style]="radioTypesEnum.button"
                    [icon]="'fa-regular fa-duotone fa-objects-align-right'"
                    [iconTooltip]="'PageBuilder.formField.tooltip.alignRight'"
                    hiddenLabel="PageBuilder.formField.tooltip.alignRight"
                    [(ngModel)]="value.buttonAlignment"
                    (onClick)="setStyle(buttonAlignmentEnum.right, 'buttonAlignment')"
                ></agpr-radio>
            </div>

            <div class="agpr-buttonStyleField-fieldRow">
                <div class="agpr-buttonStyleField-fieldRow-item">
                    <agpr-dropdown-field
                        class="agpr-buttonStyleField-font"
                        [id]="id + '_fontFamilyDropdown'"
                        [value]="value.fontFamily"
                        [field]="fontFamilyField"
                        inputTooltip="PageBuilder.formField.tooltip.fontName"
                        (changes)="setStyle($event, fontFamilyField.property)"
                    ></agpr-dropdown-field>
                </div>
                <div class="agpr-buttonStyleField-textFormattingButtons">
                    <agpr-checkbox
                        class="agpr-buttonStyleField-button"
                        [id]="id + '_buttonStyleField_bold'"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        icon="agpr-i-font-bold"
                        tooltip="PageBuilder.formField.tooltip.bold"
                        [(ngModel)]="value.bold"
                        (onChange)="setStyle($event, 'bold')"
                    ></agpr-checkbox>
                    <agpr-checkbox
                        class="agpr-buttonStyleField-button"
                        [id]="id + '_buttonStyleField_italics'"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        icon="agpr-i-font-italic"
                        tooltip="PageBuilder.formField.tooltip.italics"
                        [(ngModel)]="value.italics"
                        (onChange)="setStyle($event, 'italics')"
                    ></agpr-checkbox>
                    <agpr-checkbox
                        class="agpr-buttonStyleField-button"
                        [id]="id + '_buttonStyleField_underline'"
                        [binary]="true"
                        [style]="checkboxTypesEnum.button"
                        icon="agpr-i-font-underline"
                        tooltip="PageBuilder.formField.tooltip.underline"
                        [(ngModel)]="value.underlined"
                        (onChange)="setStyle($event, 'underlined')"
                    ></agpr-checkbox>
                </div>
            </div>

            <div class="agpr-buttonStyleField-fieldRow">
                <div
                    class="agpr-buttonStyleField-fieldRow-item agpr-buttonStyleField-fontSize"
                    [pTooltip]="'PageBuilder.formField.tooltip.fontSize' | localize"
                >
                    <div class="agpr-buttonStyleField-fontSizeIcon">
                        <span class="agpr-i-font-size" aria-hidden="true"></span>
                    </div>
                    <agpr-dropdown-field
                        class="agpr-buttonStyleField-fontSizeDropdown"
                        [id]="id + '_fontSizeDropdown'"
                        [value]="value.fontSize"
                        [field]="fontSizeField"
                        (changes)="
                            setStyle($event, fontSizeField.property);
                            setButtonShape()
                        "
                    ></agpr-dropdown-field>
                </div>
                <div class="agpr-buttonStyleField-fieldRow-item">
                    <agpr-color-picker-field
                        [id]="id + '_buttonColorPicker'"
                        [field]="buttonColorPickerField"
                        [value]="value.buttonColor"
                        (changes)="setStyle($event, buttonColorPickerField.property)"
                    ></agpr-color-picker-field>
                </div>
            </div>

            <div class="agpr-buttonStyleField-fieldRow">
                <div class="agpr-buttonStyleField-fieldRow-item">
                    <agpr-color-picker-field
                        class="agpr-buttonStyleField-fontColor"
                        [id]="id + '_textFontColorPicker'"
                        [field]="fontColorPickerField"
                        [value]="value.fontColor"
                        (changes)="setStyle($event, fontColorPickerField.property)"
                    ></agpr-color-picker-field>
                </div>
                <div class="agpr-buttonStyleField-fieldRow-item">
                     <agpr-color-picker-field
                        [id]="id + '_buttonBackgroundColorPicker'"
                        [field]="buttonBackgroundColorPickerField"
                        [value]="value.buttonBackgroundColor"
                        (changes)="setStyle($event, buttonBackgroundColorPickerField.property)"
                    ></agpr-color-picker-field>
                </div>
            </div>

            <div
                class="agpr-buttonStyleField-buttonShapeLabel"
                [id]="id + '.buttonShapeLabel'"
            >
                {{ 'PageBuilder.formField.button.stylesCornerLabel' | localize }}
            </div>
            <div class="agpr-buttonStyleField-fieldRow">
                <agpr-slider-input
                    class="agpr-buttonStyleField-buttonShape"
                    [id]="id + '_button_corner_slider'"
                    [min]="0"
                    [max]="buttonShapeInputMax"
                    [step]="buttonShapeInputStep"
                    [showValue]="false"
                    leftIcon="agpr-i-squared"
                    leftTooltip="PageBuilder.formField.tooltip.sharpCorner"
                    rightIcon="agpr-i-rounded"
                    rightTooltip="PageBuilder.formField.tooltip.roundedCorner"
                    [ariaLabelledBy]="id + '.buttonShapeLabel'"
                    [ariaValueText]="value.buttonShape + 'px'"
                    [(ngModel)]="value.buttonShape"
                    (ngModelChange)="setStyle($event, 'buttonShape')"
                ></agpr-slider-input>
            </div>
        </div>

        <agpr-block-padding
            class="agpr-buttonStyleField-blockPadding"
            [id]="id + '_padding'"
            [(padding)]="value.padding"
            (paddingChanged)="setStyle($event, 'padding')"
        ></agpr-block-padding>
    } @else {
        <div class="agpr-buttonStyleField">
            <agpr-message [severity]="messageSeverityEnum.info">
                {{ "PageBuilder.styles.expertStyleAppliedPreMessage" | localize }}
                <span style="font-weight: bold">
                    {{ field.label | localize }}
                </span>
                {{ "PageBuilder.styles.expertStyleAppliedPostMessage" | localize }}
            </agpr-message>
        </div>
    }
</div>
